export const CONFIG = {
  get IS_DEV_OR_DEBUG() {
    return !!localStorage.getItem('debug_key');
  },
};
